// extracted by mini-css-extract-plugin
export default {"wrapper":"_d9c2a7e6","fullscreen":"_9cd9e04a","controlList":"_8596cb90","focus":"_f077019"};